import React, { Component } from 'react'
import MuiTable from '../../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CAMIONES_PENALIZADOS } from '../../../../../../config/tables'

export class TablaCamionesPenalizadosView extends Component {
  render () {
    return (
      <>
        <h2>Camiones penalizados</h2>
        <MuiTable id={TABLA_CAMIONES_PENALIZADOS} />
      </>

    )
  }
}
